import {
  groupedCategoryData,
  standaloneCategoryData,
  type CategoryPayload,
  RawCategoryEntry,
  RawStandaloneCategory,
} from './categories.data'

export type Category = {
  title: string
  sectorKey: string
  payload?: CategoryPayload
  label?: string
  parentKey?: string
  childrenKeys?: string[]
  defaultChildKey?: string
}

type CategoryEntry = RawCategoryEntry & {
  sectorKey?: string
}

const createCategoryEntries = (sectorKey: string, entries: RawCategoryEntry[]): CategoryEntry[] =>
  entries.map(entry => ({
    ...entry,
    sectorKey,
  }))

const groupedCategories: CategoryEntry[] = groupedCategoryData.flatMap(group =>
  createCategoryEntries(group.sectorKey, group.entries),
)

const standaloneCategories: RawStandaloneCategory[] = standaloneCategoryData

const parsedCategories = [...standaloneCategories, ...groupedCategories].reduce(
  (acc, current) => {
    const {
      key,
      sectorKey = 'general',
      title,
      payload,
      label,
      parentKey,
      childrenKeys,
      defaultChildKey,
    } = current
    acc[key] = {
      title,
      sectorKey,
      payload,
      label,
      parentKey,
      childrenKeys,
      defaultChildKey,
    }
    return acc
  },
  {} as Record<string, Category>,
)

const categories: { [key: string]: Category } = parsedCategories

Object.entries(categories).forEach(([key, value]) => {
  if (value.parentKey && categories[value.parentKey]) {
    const parent = categories[value.parentKey]
    parent.childrenKeys = parent.childrenKeys ? [...parent.childrenKeys, key] : [key]
  }
})

export default categories
